var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
        'add-file',
        'col-auto',
        'm-1',
        _vm.multiple ? 'is-multiple' : 'is-single',
        _vm.gallery ? 'for-gallery' : '',
        !_vm.multiple && !_vm.gallery ? 'mx-3' : ''
    ]},[_c('q-icon',{attrs:{"icon":_vm.icon,"width":30,"height":30,"custom-class":"use-fill"}}),_c('input',{ref:"files",staticClass:"file-upload",attrs:{"id":"primary-file-input","multiple":_vm.multiple,"name":_vm.multiple ? '' : _vm.name,"accept":_vm.accept,"type":"file"},on:{"change":_vm.onFileUpload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }